import Character, { IImages } from "../characters/Character"
import Inventory from "../inventory/Inventory"
import { TArmor } from "./Armor"
import { TWeapon } from "./Weapon"

export type TItem = 'potion' | 'armor' | 'weapon' | null

export interface IItem {
    initType: TItem
    initCount: number
    initCost: number
    initImages: IImages
    initArmorType: TArmor
    initWeaponType: TWeapon
    initStackable: boolean
    initName: string
    initRestoreValue: number
    initArmorValue: number
    initWeaponDamage: number
}

export interface IItemLvl {
    lvl: number
    itemToLvlUpName: string
    itemToLvlUpAmount: number
    itemToLvlUpImg: IImages
}

export const initItem: IItem = {
    initType: null,
    initCount: 0,
    initCost: 0,
    initImages: { webp: '', img: '' },
    initArmorType: null,
    initWeaponType: null,
    initStackable: false,
    initName: '',
    initRestoreValue: 0,
    initArmorValue: 0,
    initWeaponDamage: 0
}

export class Item {
    protected type: TItem
    protected count: number
    protected cost: number
    protected images: IImages
    protected stackable: boolean
    protected name: string
    protected restoreValue: number
    protected armorValue: number
    protected weaponDamage: number
    protected itemLvl: IItemLvl

    constructor(item: IItem) {
        this.type = item.initType
        this.count = item.initCount
        this.cost = item.initCost
        this.images = item.initImages
        this.stackable = item.initStackable
        this.name = item.initName
        this.restoreValue = item.initRestoreValue
        this.armorValue = item.initArmorValue
        this.weaponDamage = item.initWeaponDamage
        this.itemLvl = {
            lvl: 1,
            itemToLvlUpName: '',
            itemToLvlUpAmount: 0,
            itemToLvlUpImg: { webp: '', img: '' }
        }
    }

    useItem(character: Character, characterInventory: Inventory) { }

    getImg() {
        return this.images
    }

    getCost() {
        return this.cost
    }

    getCount() {
        return this.count
    }

    getStackable() {
        return this.stackable
    }

    getType() {
        return this.type
    }

    setCount(newCount: number) {
        this.count = newCount
    }

    getName() {
        return this.name
    }

    getRestoreValue() {
        return this.restoreValue
    }

    getArmorValue() {
        return this.armorValue
    }

    getWeaponDamage() {
        return this.weaponDamage
    }

    sellItem(character: Character, characterInventory: Inventory, index: number) {
        this.setCount(this.getCount() - 1)
        character.addGold(this.getCost())
        if (this.getCount() === 0) {
            characterInventory.deleteFromInventory(index)
        }
    }

    getClone() {
        return new Item({
            initType: this.type,
            initCount: this.count,
            initCost: this.cost,
            initImages: this.images,
            initArmorType: null,
            initWeaponType: null,
            initStackable: this.stackable,
            initName: this.name,
            initRestoreValue: this.restoreValue,
            initArmorValue: this.armorValue,
            initWeaponDamage: this.weaponDamage
        })
    }

    setItemLvl() { }

    getItemLvl() {
        return this.itemLvl
    }
}